import PropTypes from "prop-types";

const AttractLoop = {
	isVisible: PropTypes.bool,
};

export default {
	AttractLoop,
};
